// This function allow to reference all chunks
__webpack_require__.hu = (chunkId) => (chunkId + "." + __webpack_require__.h() + ".hot-update.js");